import { render, staticRenderFns } from "./TastingList.vue?vue&type=template&id=3e8e4a20&scoped=true&"
import script from "./TastingList.vue?vue&type=script&lang=js&"
export * from "./TastingList.vue?vue&type=script&lang=js&"
import style0 from "./TastingList.vue?vue&type=style&index=0&id=3e8e4a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8e4a20",
  null
  
)

export default component.exports